export const MapStatus = {
  IDLE: 'idle',
  PENDING: 'pending',
  FAILED: 'failed',
  READY: 'ready'
}
